import { render, staticRenderFns } from "./cardEval.vue?vue&type=template&id=2188836a&"
import script from "./cardEval.vue?vue&type=script&lang=js&"
export * from "./cardEval.vue?vue&type=script&lang=js&"
import style0 from "./cardEval.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports